export default __webpack_public_path__ + "img/Total.ce00258c.png";